module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"hour":"ساعت","minute":"دقیقه","second":"ثانیه","untilEnd":"تا اتمام این پیشنهاد","departingHour":"ساعت خروج","arrivingHour":"ساعت ورود","purchaseTicket":"خرید بلیط"}}')
  delete Component.options._Ctor
}
